/** Explore mega menu: Programs links */
export const EXPLORE_PROGRAMS = [
  {
    to: "/programs?type=Virtual%20internship",
    title: "Internships",
    tagline: "Experience careers as they unfold",
    icon: "briefcase",
  },
  {
    to: "/programs?type=Skill%20development",
    title: "Skill Development Programs",
    tagline: "Build skills that last forever",
    icon: "rocket",
  },
];

/** Primary India hub shown on the India landing site */
export const INDIA_OFFICE = {
  city: "Gurgaon, India",
  address: "104, First Floor, BPTP Park Centra, Sector 30, Gurgaon, 122001",
  phone: "+91 8874 200 200",
  tel: "+918874200200",
};

export const LOCATIONS = [
  {
    city: "Riyadh, KSA",
    address: "UniHawk, 109, G Floor, UNBOX Community, Al Olaya, Riyadh, Saudi Arabia",
    phone: "+966 50 172 5915",
    tel: "+966501725915",
  },
  {
    city: "Manama, Bahrain",
    address: "Office 82, 8th Floor, The Address Business Center, Al Seef Area, Manama",
    phone: "+973 3936 3571",
    tel: "+97339363571",
  },
  {
    city: "Sharjah, UAE",
    address: "Office 1301, 13th Floor, Tabarak Tower, Al Mamzar, Sharjah",
    phone: "+971 52 228 4065",
    tel: "+971522284065",
  },
  {
    city: "Barsha Heights, Dubai",
    address: "Office 20C14, 20th Floor, I Rise Tower, Barsha Heights, Dubai, UAE",
    phone: "+971 56 199 2708",
    tel: "+971561992708",
  },
  {
    city: "DIFC / Sheikh Zayed Rd, Dubai",
    address: "Office 1701, 17th Floor, Al Saqr Business Tower, Sheikh Zayed Road, Dubai",
    phone: "+971 50 877 8589",
    tel: "+971508778589",
  },
  {
    city: "Abu Dhabi, UAE",
    address: "Office 1402, 14th Floor, Salam HQ Building, Sheikh Zayed Bin Sultan St.",
    phone: "+971 56 859 2259",
    tel: "+971568592259",
  },
  {
    city: "Doha, Qatar",
    address: "Office 4002, 40th Floor, The Palm Tower B, West Bay, Doha, Qatar",
    phone: "+974 3029 0949",
    tel: "+97430290949",
  },
  {
    city: "Kuwait City",
    address: "15th Floor, Hamad Tower, Khalid Ibn Al Waleid Street, Kuwait",
    phone: "+965 9744 5902",
    tel: "+96597445902",
  },
  INDIA_OFFICE,
];

/** Footer nav: row 1 = programmes; row 2 = contact actions (Contact starts the second line). */
export const FOOTER_LINK_ROWS = [
  [
    { href: "/about", label: "About Us" },
    { href: "/programs", label: "Programmes" },
    { href: "/programs?type=Virtual%20internship", label: "Virtual Internships" },
    { href: "/programs?type=Skill%20development", label: "Skill Development" },
  ],
  [
    { href: "/contact", label: "Contact" },
    { href: "/consultation", label: "Book Consultation" },
  ],
];
